import React, { useContext, useEffect, useState } from "react"
import { motion, useMotionValue } from "framer-motion"
import times from "lodash/times"
// eslint-disable-next-line @typescript-eslint/no-var-requires
const path = require("svg-path-properties")
import { Link as Linky, Element, Events, scrollSpy } from "react-scroll"
// import Container from "../../components/Container/Container"
import { circlePath } from "../../utils/index"
import ActiveCircles from "./ActiveCircles"
import {
  useWindowSize,
  useWindowWidth,
  useWindowHeight,
} from "@react-hook/window-size"
import { useCoords } from "../../store/CoordsContext"
import MiniPlayer from "components/Player/MiniPlayer"
import { Wrapper, StyledP } from "./styles"
import { calculateTextOnCircle } from "../../utils/index"
import { getGPUTier } from "detect-gpu"
import { getPlanetId } from "../../layouts/index"
import navigation from "../../layouts/navigation"
import { FullSpecContext } from "../../store/FullSpecContext"
import { isMobile } from "utils"

type Props = {
  pageContext: any
}

const SvgCircleAnimation: React.FC<Props> = ({ pageContext }): JSX.Element => {
  const [coords] = useCoords()
  const onlyWidth = useWindowWidth()
  const onlyHeight = useWindowHeight()
  const r = onlyWidth
    ? onlyHeight > 800
      ? onlyWidth * 0.155
      : onlyWidth * 0.12
    : 300 // Promień kółek
  const X = coords?.x ? coords?.x - 10 : onlyWidth / 4 - 40 // Koordynaty do ustawiania pathów
  const Y = coords?.y ? coords?.y : onlyHeight / 2 // Koordynaty do ustawiania pathów
  const properties = new path.svgPathProperties(circlePath(X, Y, r, 90))
  const length = properties.getTotalLength()
  const quarterDistance = Math.floor(length / 3)
  const planets = pageContext.post.fields.sections
  const m = useMotionValue(length)
  const [activeSection, setActiveSection] = useState(0)
  const fullSpecContext = useContext(FullSpecContext)

  useEffect(() => {
    //console.log("Coords", coords)
  }, [coords])

  if (!isMobile)
    return (
      <Wrapper
        style={{
          width: `${onlyWidth / 2}px`,
          height: `${onlyHeight}px`,
        }}
      >
        <svg
          width={onlyWidth / 2}
          height={onlyHeight}
          viewBox={`0 0 ${onlyWidth / 2} ${onlyHeight}`}
          id="planetBorder"
        >
          <g>
            {!fullSpecContext.fullSpec && (
              <image
                // @ts-ignore
                href={`/lowres/${
                  navigation[getPlanetId()]?.lowSpecPlanet || ""
                }`}
                width={(r - 60) * 2}
                height={(r - 60) * 2}
                x={X - (r - 60)}
                y={Y - (r - 60)}
              ></image>
            )}
            <motion.path
              id="elo"
              fill={"transparent"}
              stroke={"#dad2d2"}
              strokeWidth={1}
              strokeLinecap="round"
              strokeDasharray={5}
              style={{
                opacity: 0.2,
              }}
              // initial={{ pathLength: 0 }}
              // animate={{ pathLength: 1 }}
              // transition={{ duration: 4, ease: "easeInOut" }}
              initial={{ opacity: 0.6, scale: 1, rotate: 0 }}
              animate={{ opacity: 0.2, scale: 1.01, rotate: 360 }}
              transition={{
                rotate: { duration: 200, yoyo: Infinity },
                opacity: { duration: 2, yoyo: Infinity },
                scale: { duration: 2, yoyo: Infinity, delay: 1 },
              }}
              d={circlePath(X, Y, r - 40, 90)}
            ></motion.path>
            <motion.path
              fill={"transparent"}
              stroke={"#dad2d2"}
              strokeWidth={1}
              strokeLinecap="round"
              initial={{ pathLength: 0, opacity: 0.6, scale: 1 }}
              animate={{ pathLength: 1, opacity: 0.2, scale: 1.01 }}
              transition={{
                pathLength: { duration: 4, ease: "easeInOut" },
                opacity: { duration: 2, yoyo: Infinity },
                scale: { duration: 2, yoyo: Infinity, delay: 4 },
              }}
              d={circlePath(X, Y, r - 20, 0)}
            ></motion.path>
            <path
              fill={"transparent"}
              stroke={"#dad2d2"}
              strokeWidth={1}
              d={circlePath(X, Y, r, 90)}
              style={{
                opacity: 0.6,
              }}
            ></path>
            <motion.path
              fill={"transparent"}
              stroke={"red"}
              strokeWidth={1}
              strokeDasharray={length}
              strokeDashoffset={m}
              transition={{ duration: 5, repeat: Infinity }}
              d={circlePath(X, Y, r, 90, 1)}
            ></motion.path>
            {planets.map((x: any, i: number) => {
              return (
                <Linky
                  activeClass="activeDOT"
                  className="test4"
                  to={`element_${i}`}
                  containerId={"scene"}
                  spy={true}
                  key={i}
                  smooth={true}
                  duration={500}
                  // offset={-100}
                  ignoreCancelEvents
                  isDynamic
                  // offset={50}
                  onSetActive={(to: any) => {
                    setActiveSection(i)
                    m.set(
                      length - (quarterDistance / planets.length) * (i + 0.1)
                    )
                  }}
                >
                  <>
                    <motion.circle
                      onClick={() => {
                        setTimeout(() => {
                          if (activeSection !== i) {
                            setActiveSection(i)
                            m.set(
                              length -
                                (quarterDistance / planets.length) * (i + 0.1)
                            )
                          }
                        }, 600)
                      }}
                      cx={0}
                      cy={0}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "10px",
                        height: "10px",
                        // backgroundColor: "#be7367",
                        offsetPath: circlePath(X, Y, r, 90),
                      }}
                      animate={{
                        transitionEnd: {
                          cy: properties.getPointAtLength(
                            length -
                              (quarterDistance / planets.length) * (i + 0.1)
                          ).y,
                          cx: properties.getPointAtLength(
                            length -
                              (quarterDistance / planets.length) * (i + 0.1)
                          ).x,
                        },
                        cx: times(
                          Math.ceil(
                            (quarterDistance / planets.length) * (i + 0.1)
                          ),
                          s => {
                            return properties.getPointAtLength(length - s).x
                          }
                        ),
                        cy: times(
                          Math.ceil(
                            (quarterDistance / planets.length) * (i + 0.1)
                          ),
                          s => {
                            return properties.getPointAtLength(length - s).y
                          }
                        ),
                      }}
                      transition={{ duration: 1, ease: "easeOut" }}
                      key={`__${i}`}
                      // stroke={"#dad2d2"}
                      strokeWidth={1}
                      fill={i <= activeSection ? "#df4a32" : "#dad2d2"}
                      className={"circle"}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      r={5}
                    ></motion.circle>
                    {/* {activeSection === i && ( */}
                    <ActiveCircles
                      activeSection={activeSection === i}
                      cx={
                        properties.getPointAtLength(
                          length -
                            (quarterDistance / planets.length) * (i + 0.1)
                        ).x
                      }
                      cy={
                        properties.getPointAtLength(
                          length -
                            (quarterDistance / planets.length) * (i + 0.1)
                        ).y
                      }
                    />
                    {/* )} */}
                  </>
                </Linky>
              )
            })}
          </g>
          <g>
            {planets.map((x: any, i: number) => {
              return (
                <Linky
                  activeClass="actives"
                  className="circleTexts"
                  to={`element_${i}`}
                  containerId={"scene"}
                  spy={true}
                  key={`_${i}`}
                  smooth={true}
                  duration={500}
                  // offset={-100}
                  ignoreCancelEvents
                  // spyThrottle={400}
                  isDynamic
                  // offset={50}
                  // onSetActive={(to: any) => {
                  //   m.set(length - (quarterDistance / planets.length) * (i + 0.1))
                  // }}
                  onSetActive={(to: any) => {
                    setActiveSection(i)
                    m.set(
                      length - (quarterDistance / planets.length) * (i + 0.1)
                    )
                  }}
                  onClick={() => {
                    setTimeout(() => {
                      if (activeSection !== i) {
                        setActiveSection(i)
                        m.set(
                          length -
                            (quarterDistance / planets.length) * (i + 0.1)
                        )
                      }
                    }, 600)
                  }}
                >
                  <g
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <foreignObject
                      width={160}
                      height={60}
                      transform={`translate(${
                        calculateTextOnCircle(planets.length, i).x
                      } ${calculateTextOnCircle(planets.length, i).y})`}
                      x={
                        properties.getPointAtLength(
                          length - (length / 3 / planets.length) * i
                        ).x
                      }
                      y={
                        properties.getPointAtLength(
                          length - (length / 3 / planets.length) * i
                        ).y
                      }
                    >
                      <StyledP
                        style={{
                          cursor: "pointer",
                          fontSize: 12,
                          textTransform: "uppercase",
                          letterSpacing: "0.16em",
                          fontFamily: "Oswald",
                          color: activeSection === i ? "#df4a32" : "#dad2d2",
                        }}
                      >
                        {typeof x.title === "string"
                          ? x.title.replace(":", "")
                          : ""}
                      </StyledP>
                    </foreignObject>
                  </g>
                </Linky>
              )
            })}
          </g>
        </svg>
        <MiniPlayer r={r} x={X} y={Y} />
      </Wrapper>
    )

  return <></>
}

export default SvgCircleAnimation
